import React from "react";

const REGIME_CONFIG = {
  BULL:    { bg: "#f0fdf4", border: "#16a34a", text: "#15803d", label: "BULL MARKET", desc: "All buy signals active — full position sizing" },
  NEUTRAL: { bg: "#eff6ff", border: "#2563eb", text: "#1d4ed8", label: "NEUTRAL",     desc: "Selective signals only — 50% position sizing" },
  BEAR:    { bg: "#fff7ed", border: "#ea580c", text: "#c2410c", label: "BEAR MARKET", desc: "Watch mode — no new buys. Monitor watchlist." },
};

export default function RegimeBanner({ regime, breadth, stockCount, lastUpdated }) {
  const cfg = REGIME_CONFIG[regime] || REGIME_CONFIG.NEUTRAL;
  const timeStr = lastUpdated
    ? lastUpdated.toLocaleTimeString("en-IN", { hour: "2-digit", minute: "2-digit" })
    : "--:--";

  return (
    <div style={{
      background: cfg.bg,
      border: `1.5px solid ${cfg.border}`,
      borderRadius: 8,
      padding: "12px 20px",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      flexWrap: "wrap",
      gap: 8,
      marginBottom: 20
    }}>
      <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
        <span style={{
          fontWeight: 800, fontSize: 13, color: cfg.text,
          letterSpacing: "0.08em", fontFamily: "monospace"
        }}>
          {cfg.label}
        </span>
        <span style={{ fontSize: 13, color: cfg.text, opacity: 0.8 }}>
          {cfg.desc}
        </span>
      </div>
      <div style={{ display: "flex", gap: 20, fontSize: 12, color: cfg.text }}>
        {breadth != null && (
          <span>Breadth <strong>{(breadth * 100).toFixed(1)}%</strong></span>
        )}
        <span>{stockCount} stocks</span>
        <span>Updated {timeStr}</span>
      </div>
    </div>
  );
}
